// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App.vue'
import './permission'
import store from './store'
import router from './router'
import HighchartsVue from 'highcharts-vue'
import vuetify from './plugins/vuetify'
import '@mdi/font/css/materialdesignicons.css'

import './directives'
import './utils/filters'

Vue.config.productionTip = false
Vue.use(HighchartsVue)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  vuetify,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js